<template>
    <div class="product__item product__item--accordion" :index="index" ref="row">
        <input :id="'domain_' + index" type="radio" name="domain" :checked="checked" @change="scrollToElement" />
        <label :for="'domain_' + index" class="product__item-header | u-cursor-pointer">
            <span>
                {{ domain.domain }}
            </span>
        </label>
        <div class="product__item-body">
            <ssl-plans :domain="domain" />
        </div>
    </div>
</template>

<script>
import SslPlans from './SslPlans.vue';
import accordionMixin from '../../mixins/accordion';

export default {
    props: {
        domain: Object,
        index: Number
    },
    mixins: [accordionMixin],
    components: {
        SslPlans
    }
};
</script>
